interface WindowControlsProps {
  maximized: boolean
}

export function WindowControls({ maximized }: WindowControlsProps) {
  const controls = window.ledgerDesktop.windowControls

  return (
    <div className="flex h-[38px] items-stretch">
      {/* Minimize */}
      <button
        type="button"
        onClick={() => controls.minimize()}
        className="flex w-[46px] items-center justify-center text-slate-400 transition-colors hover:bg-white/10 hover:text-slate-200"
        aria-label="Minimize"
      >
        <svg width="10" height="1" viewBox="0 0 10 1" fill="currentColor">
          <rect width="10" height="1" />
        </svg>
      </button>

      {/* Maximize / Restore */}
      <button
        type="button"
        onClick={() => controls.maximize()}
        className="flex w-[46px] items-center justify-center text-slate-400 transition-colors hover:bg-white/10 hover:text-slate-200"
        aria-label={maximized ? 'Restore' : 'Maximize'}
      >
        {maximized ? (
          // Restore icon (overlapping rectangles)
          <svg width="10" height="10" viewBox="0 0 10 10" fill="none" stroke="currentColor" strokeWidth="1">
            <rect x="2" y="3" width="7" height="7" rx="0.5" />
            <path d="M3 3V1.5a.5.5 0 0 1 .5-.5H9a1 1 0 0 1 1 1v5.5a.5.5 0 0 1-.5.5H9" />
          </svg>
        ) : (
          // Maximize icon (single rectangle)
          <svg width="10" height="10" viewBox="0 0 10 10" fill="none" stroke="currentColor" strokeWidth="1">
            <rect x="0.5" y="0.5" width="9" height="9" rx="0.5" />
          </svg>
        )}
      </button>

      {/* Close */}
      <button
        type="button"
        onClick={() => controls.close()}
        className="flex w-[46px] items-center justify-center text-slate-400 transition-colors hover:bg-red-600 hover:text-white"
        aria-label="Close"
      >
        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" stroke="currentColor" strokeWidth="1.2">
          <path d="M1 1l8 8M9 1l-8 8" />
        </svg>
      </button>
    </div>
  )
}
